<template>
  <el-button class="square-button">
    <svg class="button-icon" aria-hidden="true">
      <use :xlink:href="iconValue"></use>
    </svg>
  </el-button>
</template>
<script>
import {ElButton} from 'element-ui'
export default {
  extends: ElButton,
  name: "SquareButton",
  data() {
    return {

    };
  },
  computed: {

  },
  components: {

  },
  props: ["iconValue"],
}

</script>
<style lang="scss">
//方形按钮的样式
.square-button {
  height: 32px !important;
  width: 32px !important;
  padding: 0 !important;
  background: #FAFAFA !important;
  vertical-align: center;
}

.square-button:hover {
  border-color: #33F !important;
  border-width: 1px;
  background-color: #EBEBFE !important;
  z-index: 1;
}

//按钮中图标的样式
.button-icon {
  width: 16px;
  height: 16px;
  outline-style:none;
  fill: currentColor;
  overflow: hidden;
  margin-top: 3px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/squareButton/squareButton.vue